var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css } from 'lit';
import { property } from 'lit/decorators.js';
import { Tool } from '../../../model/tool/Tool';
export class ToggleWindow extends LitElement {
    close() { }
}
ToggleWindow.styles = css `
        :host {
        display: block;
        width: 100%; /* permet au container de s'adapter */
        }
    `;
__decorate([
    property({ type: Object })
], ToggleWindow.prototype, "tool", void 0);
//# sourceMappingURL=ToggleWindow.js.map